import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

// All 24 applications from the reference images
const applications = [
  // Row 1
  { name: "RCC Roads", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/0r6lwjk9_download.jpg" },
  { name: "Pavements", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/3k6ehzgd_download%20%281%29.jpg" },
  { name: "Drainage", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/ztgfqxyh_download%20%282%29.jpg" },
  // Row 2
  { name: "Crash Barriers", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/hestjry7_images.jpg" },
  { name: "Friction Slab", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/tn7dgsou_download%20%283%29.jpg" },
  { name: "Industrial Floorings", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/lylnzzfz_download%20%284%29.jpg" },
  // Row 3
  { name: "Parkings", image: "https://images.unsplash.com/photo-1506521781263-d8422e82f27a?w=400&h=300&fit=crop" },
  { name: "Concrete Slabs", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/kdhk01a8_download%20%285%29.jpg" },
  { name: "Chemical Plants", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/wamwzkn1_download%20%286%29.jpg" },
  // Row 4
  { name: "Precast", image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=300&fit=crop" },
  { name: "Foundations", image: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=400&h=300&fit=crop" },
  { name: "Retaining Walls", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/sqk4nf3b_download%20%287%29.jpg" },
  // Row 5
  { name: "Columns", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/60x7frl5_download.jpg" },
  { name: "Water & Waste Water Treatment Plants", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/ddv2s009_download%20%288%29.jpg" },
  { name: "Dams, Sea Walls & Marine Applications", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/rsou3om5_download%20%282%29.jpg" },
  // Row 6
  { name: "RCC Floorings Near Sea", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/oe1alwmn_download%20%283%29.jpg" },
  { name: "Highway Construction", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/qqcix6bf_download%20%281%29.jpg" },
  { name: "Bridge Decks", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/zcq6cubt_download%20%284%29.jpg" },
  // Row 7
  { name: "Barrier Walls", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/z6xuomk1_download%20%285%29.jpg" },
  { name: "Underground Water Tanks", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/zh30ez5f_download%20%287%29.jpg" },
  { name: "Swimming Pools", image: "https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=400&h=300&fit=crop" },
  // Row 8
  { name: "Approach Slab", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/5kaumilh_download%20%286%29.jpg" },
  { name: "Hospital MRI Areas", image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=400&h=300&fit=crop" },
  { name: "Tunneling & Temporary Reinforcement", image: "https://customer-assets.emergentagent.com/job_nextgen-gfrp/artifacts/fxgfbzob_download%20%289%29.jpg" },
];

export default function ApplicationsPage() {
  return (
    <div data-testid="applications-page">
      {/* Hero Section */}
      <section className="bg-white border-b border-slate-200" data-testid="applications-hero">
        <div className="section-container py-20 md:py-28">
          <div className="max-w-3xl">
            <div className="accent-line mb-6"></div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 font-['Barlow_Condensed']">
              Applications
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl">
              GFRP reinforcement solutions for diverse infrastructure and construction applications 
              across industries.
            </p>
          </div>
        </div>
      </section>

      {/* Applications Grid */}
      <section className="section-spacing bg-yellow-400" data-testid="applications-grid">
        <div className="section-container">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-white font-['Barlow_Condensed']">
              Where GFRP Makes a Difference
            </h2>
            <p className="text-yellow-100 mt-4 max-w-2xl mx-auto">
              From roads to hospitals, our GFRP products serve 24+ application areas
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
            {applications.map((app, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow group"
                data-testid={`application-card-${index}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={app.image}
                    alt={app.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-4 bg-white">
                  <h3 className="font-bold text-slate-900 font-['Barlow_Condensed'] text-sm lg:text-base text-center leading-tight">
                    {app.name}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why GFRP for These Applications */}
      <section className="section-spacing bg-white" data-testid="why-section">
        <div className="section-container">
          <div className="text-center mb-12">
            <div className="accent-line mx-auto mb-6"></div>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Barlow_Condensed']">
              Why Choose GFRP for Your Application?
            </h2>
          </div>

          {/* Benefits Grid - 2 columns */}
          <div className="grid md:grid-cols-2 gap-x-16 gap-y-10 mb-20">
            {/* Corrosion Resistant */}
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 font-['Barlow_Condensed'] text-xl mb-2">
                  Corrosion Resistant
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  GFRP Bars are compatible with water, salt, and other chemicals. GFRP does not rust or corrode; it improves the life span of slab building construction.
                </p>
              </div>
            </div>

            {/* Cost Effective */}
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 font-['Barlow_Condensed'] text-xl mb-2">
                  Cost Effective
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  GFRP Rebar is a <span className="text-yellow-400 font-semibold">cost-effective</span> material. It decreases base slab maintenance cost and installation costs. GFRP improves the life span of construction.
                </p>
              </div>
            </div>

            {/* Stronger */}
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 font-['Barlow_Condensed'] text-xl mb-2">
                  Stronger
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  GFRP Rebars are two times <span className="text-yellow-400 font-semibold">stronger</span> than traditional steel reinforcement bars. GFRP bars increase the strength of base slab constructions.
                </p>
              </div>
            </div>

            {/* Nonconductive */}
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 font-['Barlow_Condensed'] text-xl mb-2">
                  Nonconductive
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  GFRP Rebar does not conduct electricity, making it ideal for base slabs in electrical-sensitive environments.
                </p>
              </div>
            </div>

            {/* Lighter */}
            <div className="flex gap-4 md:col-span-2 md:max-w-[calc(50%-2rem)]">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 font-['Barlow_Condensed'] text-xl mb-2">
                  Lighter
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  GFRP Bars are ¼ <span className="text-yellow-400 font-semibold">lighter</span> than traditional steel bars. GFRP makes base slab construction lighter and provides more strength.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Understanding the Need for Base Slabs */}
      <section className="section-spacing bg-slate-50" data-testid="base-slabs-section">
        <div className="section-container">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Barlow_Condensed']">
              Understanding the Need for Base Slabs in Modern Construction
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Structural Integrity */}
            <div className="bg-white border border-slate-200 p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-yellow-400 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="font-bold text-slate-900 font-['Barlow_Condensed'] text-xl mb-3">
                Structural Integrity
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                It provides a solid foundation that helps maintain the stability of the structure, reducing the risk of cracks and shifting over time.
              </p>
            </div>

            {/* Load Distribution */}
            <div className="bg-white border border-slate-200 p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-yellow-400 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h3 className="font-bold text-slate-900 font-['Barlow_Condensed'] text-xl mb-3">
                Load Distribution
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                The base slab evenly spreads the weight of the building, preventing uneven settling or foundation damage.
              </p>
            </div>

            {/* Durability */}
            <div className="bg-white border border-slate-200 p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-yellow-400 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="font-bold text-slate-900 font-['Barlow_Condensed'] text-xl mb-3">
                Durability
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Reinforced base slabs, especially with materials like GFRP rebar, extend the foundation's lifespan, reducing the need for repairs or maintenance.
              </p>
            </div>

            {/* Moisture Protection */}
            <div className="bg-white border border-slate-200 p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-yellow-400 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707" />
                </svg>
              </div>
              <h3 className="font-bold text-slate-900 font-['Barlow_Condensed'] text-xl mb-3">
                Moisture Protection
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                A base slab acts as a barrier, protecting the building's foundation from groundwater, moisture, and soil erosion.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-spacing bg-slate-900 relative noise-overlay" data-testid="applications-cta">
        <div className="section-container relative z-10 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white font-['Barlow_Condensed'] mb-6">
            Have a Specific Application in Mind?
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto mb-10">
            Our engineering team can help you determine if GFRP is right for your project 
            and provide customized solutions.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button 
                className="bg-yellow-400 text-white hover:bg-yellow-500 font-bold uppercase tracking-wider rounded-none px-8 py-6"
                data-testid="applications-contact-btn"
              >
                Discuss Your Project
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <Link to="/products">
              <Button 
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-slate-900 font-bold uppercase tracking-wider rounded-none px-8 py-6"
                data-testid="applications-products-btn"
              >
                View Products
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
